export default __webpack_public_path__ + "static/media/fad-arrows-vert.86a543a9.svg";